'use client'
 
import { notFound } from 'next/navigation'
import { useEffect } from 'react'
 
export default function Error({ error, reset }) {
  useEffect(() => {
    // Log the error to an error reporting service
    console.log(error)
  }, [error])
 
  return (
    notFound()
  )
}